module.exports = __webpack_public_path__ + "img/question-after-bg.a9584b12.png";